import { c as _c } from "react/compiler-runtime";
import { Button } from '@sprd/sprd-component-kit/v2';
import clsx from 'clsx';
import { useLocale, useTranslations } from 'next-intl';
import Link from 'next/link';
import { getPathname } from '@/i18n/navigation';
import { sanitizeQuery } from '@/utility/urls';
import { type ProductTypeWithEmbroideryInformation } from '../actions/productType';
type CTASectionDesktopProps = {
  productType: ClientProductType<ProductTypeWithEmbroideryInformation>;
  selectedSizeId: string | undefined;
  selectedAppearanceId: string;
  outOfStock: boolean;
  handleAddToCart: (sizeId: string) => void;
  showAddToCart: boolean;
  onSizeMissing: () => void;
};
export const CTASectionDesktop = t0 => {
  const $ = _c(48);
  const {
    productType,
    selectedSizeId,
    selectedAppearanceId,
    outOfStock,
    handleAddToCart,
    showAddToCart,
    onSizeMissing
  } = t0;
  const t = useTranslations();
  const locale = useLocale();
  let t1;
  if ($[0] !== locale || $[1] !== productType.id || $[2] !== selectedAppearanceId) {
    t1 = (sizeId, embroidery) => getPathname({
      href: {
        pathname: "/cyo/designer",
        query: sanitizeQuery({
          productType: productType.id,
          appearance: selectedAppearanceId,
          size: sizeId,
          embroidery
        })
      },
      locale
    });
    $[0] = locale;
    $[1] = productType.id;
    $[2] = selectedAppearanceId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getDesignerHref = t1;
  const t2 = showAddToCart ? "grid grid-cols-[repeat(auto-fit,minmax(15rem,1fr))] gap-3" : "flex flex-col gap-4";
  let t3;
  if ($[4] !== t2) {
    t3 = clsx(t2);
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== productType.isEmbroideryOnly) {
    t4 = clsx({
      "hidden!": productType.isEmbroideryOnly
    }, "w-full");
    $[6] = productType.isEmbroideryOnly;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = selectedSizeId ?? "";
  let t6;
  if ($[8] !== getDesignerHref || $[9] !== t5) {
    t6 = getDesignerHref(t5);
    $[8] = getDesignerHref;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("cyoAssortmentDetailPage.createNow");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <Link href={t6}>{t7}</Link>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== outOfStock || $[17] !== t4 || $[18] !== t8) {
    t9 = <Button variant="gradient" className={t4} size="l" disabled={outOfStock} asChild={true}>{t8}</Button>;
    $[16] = outOfStock;
    $[17] = t4;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = !productType.isEmbroideryOnly && !productType.isEmbroiderySupported;
  let t11;
  if ($[20] !== t10) {
    t11 = clsx({
      "hidden!": t10
    }, "w-full");
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const t12 = selectedSizeId ?? "";
  let t13;
  if ($[22] !== getDesignerHref || $[23] !== t12) {
    t13 = getDesignerHref(t12, true);
    $[22] = getDesignerHref;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t) {
    t14 = t("cyoAssortmentDetailPage.embroiderNow");
    $[25] = t;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t13 || $[28] !== t14) {
    t15 = <Link href={t13}>{t14}</Link>;
    $[27] = t13;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== outOfStock || $[31] !== t11 || $[32] !== t15) {
    t16 = <Button variant="gradient-border" className={t11} size="l" disabled={outOfStock} asChild={true}>{t15}</Button>;
    $[30] = outOfStock;
    $[31] = t11;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t16 || $[35] !== t3 || $[36] !== t9) {
    t17 = <div className={t3}>{t9}{t16}</div>;
    $[34] = t16;
    $[35] = t3;
    $[36] = t9;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== handleAddToCart || $[39] !== onSizeMissing || $[40] !== outOfStock || $[41] !== selectedSizeId || $[42] !== showAddToCart || $[43] !== t) {
    t18 = showAddToCart && <div><CTADivider /><Button size="l" className="w-full" disabled={outOfStock} onClick={() => {
        if (!selectedSizeId) {
          onSizeMissing();
        } else {
          handleAddToCart(selectedSizeId);
        }
      }}>{t("mpDetailPage.addToCart")}</Button></div>;
    $[38] = handleAddToCart;
    $[39] = onSizeMissing;
    $[40] = outOfStock;
    $[41] = selectedSizeId;
    $[42] = showAddToCart;
    $[43] = t;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== t17 || $[46] !== t18) {
    t19 = <div className="flex flex-col gap-3">{t17}{t18}</div>;
    $[45] = t17;
    $[46] = t18;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  return t19;
};
export const CTADivider = () => {
  const $ = _c(8);
  const t = useTranslations("cyoAssortmentDetailPage");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="h-px w-full rounded-full bg-neutral-200" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("ctaSectionDivider");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <span className="px-4 text-xs">{t1}</span>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="h-px w-full rounded-full bg-neutral-200" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <div className="flex items-center pb-3">{t0}{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};